/* eslint-disable no-param-reassign */
import axios from 'axios';

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/p/`,
  timeout: 50000,
  headers: {
    'TT-AP': '1473783471750b458b32255910223d0b4e97be66',
  }
});

export const setAuthentication = (token) => {
  api.defaults.headers.common['TT-ST'] = token;
};

api.interceptors.request.use(
  (config) => {
    if (!config.headers['TT-ST']) {
      const token = localStorage.getItem('TT-ST')?.toString();
      if (token !== 'null' && token !== 'undefined' && token) {
        config.headers['TT-ST'] = token;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data && error.response.data.error === 'NO_AUTORIZADO_ST') {
      delete error.config.headers['TT-ST'];
      return axios(error.config);
    }
    return Promise.reject(error);
  }
);

export const saveTokenAuthentication = (token) => {
  localStorage.setItem('TT-ST', token);
  setAuthentication(token);
};
